import { pb } from "./pocketbase";
import { getActiveOperator } from "../utils/operatorUtils";

// DICIONÁRIO DE MÓDULOS
export const MODULES = {
  ESTOQUE: "ESTOQUE_FABRICA",
  PEDIDOS: "LOGISTICA_PEDIDOS",
  PRODUCAO: "PRODUCAO_OFICINA",
  RESERVAS: "RESERVAS",
  ARQUIVO: "ARQUIVO_MORTO",
  GERAL: "SISTEMA",
  LOGISTICA: "LOGISTICA_PEDIDOS",
  FINANCEIRO: "FINANCEIRO",
};

// --- HELPER: NORMALIZA O USUÁRIO ---
export const getSafeUser = (user) => {
  if (!user) {
    return {
      name: "Admin (Sistema)",
      email: "sistema@interno.com",
      uid: "sistema_auto",
    };
  }

  return {
    name: user.name || "Usuário Sem Nome",
    email: user.email || user.username || "sem_email",
    uid: user.uid || user.id || "sem_id",
  };
};

/**
 * Registra uma ação no sistema
 */
export const logAction = async (
  user,
  module,
  action,
  details,
  metadata = {}
) => {
  try {
    const userInfo = getSafeUser(user);
    const cleanMetadata = JSON.parse(JSON.stringify(metadata || {}));
    const model = pb.authStore.model;
    const nameUpper = String(model?.name || "").toUpperCase();
    const userUpper = String(model?.username || "").toUpperCase();
    const isPdv = nameUpper.includes("PDV") || userUpper.includes("PDV");
    const termType = isPdv ? "PDV" : "OFICINA";

    const activeOp = getActiveOperator(termType);
    const prefix = termType;

    await pb.collection("system_logs").create({
      module: module || "GERAL",
      action: action ? action.toUpperCase() : "ACAO_DESCONHECIDA",
      details: details || "Sem detalhes",

      // User Flattened (Para facilitar busca por usuario)
      user_name: userInfo.name,
      user_email: userInfo.email,
      operador: activeOp ? `${prefix} · ${activeOp.nome}` : "",

      // JSON com tudo
      metadata: {
        ...cleanMetadata,
        user_uid: userInfo.uid
      },
    });

  } catch (error) {
    console.error("ERRO AO GRAVAR LOG:", error);
    // Não damos alert aqui para não travar o fluxo do usuário se o log falhar
  }
};
